import AppDispatcher from '../core/AppDispatcher.jsx';
import {getInvestorNames} from '../utils/ApplicationHelper';
import {ActionTypes as ApplicationActionTypes} from '../constants/ApplicationConstants';
import {investorModel, userTypes, ActionTypes, downloadableForms} from '../constants/CongratulationsConstants';
import {getKycForms, getDirectDebitAuthorithyForms, getAdditionalApplicationFormList, getConsolidateForms} from '../utils/CongratulationsHelper';
import DownloadConstants from '../constants/DownloadConstants';
import { EventEmitter } from 'events';
import DateTime from '../utils/DateTime.js';
import DownloadFormsHelper from '../utils/DownloadFormsHelper.js';
import ApplicationActions from '../actions/ApplicationActions.js';

import _ from 'lodash';

const CHANGE_EVENT = 'change';
let _investorList = [],
    _accountNumber = '',
    _isShellAccount = false,
    _product = {},
    _formModel = {},
    _downloadData = { error: false, showSpinner: false, buttonDisabled: false },
    _formList = [],
    _applicationFormList = [],
    _downloadedForm,
    _downloadedFormFileName,
    _names = [],
    _superFirstAccountNumber = '',
    _investmentOptions=[],
    _inSpecieAccounts=[],
    _adviceFee = {},
    _eAccountNumber='',
    _eOin='',
    _asfFormKillswitch=false,
    _asfCongratulationsPageKillswitch=false,
    _congratulationsPageDocumentKillswitch=false;

class CongratulationsStoreClass extends EventEmitter {
    constructor() {
        super();
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    getHeadingModel() {
        return {
            investorList: _investorList,
            accountNumber: _accountNumber,
            superFirstAccountNumber: _superFirstAccountNumber
        };
    }

    getBodyModel() {
        let investorName = '',
            date = DateTime.oneYearFromNow();

        if (this.getIsSingleAccount()){
            investorName = _investorList[0].name;
        }
        return {
            investorName: investorName,
            holdingDate: date,
            formList: _formList,
            applicationFormList: _applicationFormList
        };
    }

    getIsShellAccount(){
        return _isShellAccount;
    }

    getIsSingleAccount(){
        return _investorList.length === 1;
    }

    getProductName(){
        return _product.label;
    }

    getUserType(){
        if (!window.NOA || !window.NOA.userContext){
            return null;
        }
        let context = window.NOA.userContext;
        //public site user
        if (context.isInvestor && !context.isExisting){
            return userTypes[0];
        }
        return context.userType;
    }

    getProductCode(){
        return _product.value;
    }

    getDownloadData(){
        return _downloadData;
    }

    getDownloadFormModel(){
        const downloadFormModel = DownloadFormsHelper.getDownloadFormApplication(_formModel);
        return downloadFormModel;
    }

    getDownloadedForm(){
        return _downloadedForm;
    }

    getDownloadedFormFileName(){
        return _downloadedFormFileName;
    }
    getInvestorDetailsForRedirection(){
        return {
            eAccountNumber: _eAccountNumber,
            eOin: _eOin,
            killSwitch:_asfFormKillswitch
        };
    }

    getAsfCongratulationsPageKillSwitch(){
        return {
            killSwitch: _asfCongratulationsPageKillswitch
        };
    }

    getCongratulationsPageDocumentKillSwitch(){
        return {
            killSwitch: _congratulationsPageDocumentKillswitch
        };
    }
}

const CongratulationsStore = new CongratulationsStoreClass();

function populateFormList(formList){
    _formList = _.filter(downloadableForms[_product.value], function(item){
        return formList.indexOf(item.value) > -1;
    });
    
    let dda = getDirectDebitAuthorithyForms(_formModel, _formList);
    addDataToFormList(dda);
    
    let consolidate = getConsolidateForms(_formModel, _formList);
    addDataToFormList(consolidate);

    let kyc = getKycForms(_formList, _names);
    addDataToFormList(kyc);
}

function addDataToFormList(data){
    if (data){
        _formList.splice(data.index, 1, data.forms);
        _formList = _.flatten(_formList);
    }
}

function populateApplicationFormList(){
    _applicationFormList = _applicationFormList.concat(downloadableForms.application);
    let additionalFormList = getAdditionalApplicationFormList(_formModel);
    if (additionalFormList){
        _applicationFormList = _applicationFormList.concat(additionalFormList);
    }
}

// Store handlers
function applicationSubmitSuccess(data){
    _eAccountNumber=data.eAccountNumber;
    _eOin=data.eOin;
    if (data.formModel) {
        _formModel = _.cloneDeep(data.formModel);
        _.set(_formModel, 'form.investmentAllocation.investmentOptions', _investmentOptions);
        _.set(_formModel, 'form.inSpecieTransfer.inSpecieAccounts', _inSpecieAccounts);
        _.set(_formModel, 'form.adviceFee', _adviceFee);
    }
    if (!_formModel.id){
        _formModel.id = data.applicationId;
    }
    _accountNumber = data.accountNumber;
    _isShellAccount = data.isShellAccount;
    _investorList = [];
    _names = getInvestorNames(_formModel);
    _.forEach(data.oinList, function(oin, idx){
        let investor = _.clone(investorModel);
        investor.name = _names[idx]
        investor.oin = oin;
        _investorList.push(investor);
    });
    _formModel.isShellAccount = data.isShellAccount;
    _superFirstAccountNumber = data.superFirstAccountNumber;

    populateApplicationFormList();
    populateFormList(data.formList);
    ApplicationActions.getAsfFeeKillSwitch();
    ApplicationActions.getAsfCongratulationsPageKillSwitch();
    ApplicationActions.getCongratulationsPageDocumentKillSwitch();
}

function receiveDownloadedForm(data, isDownloadAll = false) {
    if (data) {
        if (data.attachments && data.attachments.length > 0) {
            var url = DownloadConstants.Base64String;
            _downloadedForm = url.replace('{contentType}', data.attachments[0].contentType).replace('{base64}', data.attachments[0].body);
            _downloadedFormFileName = isDownloadAll? 'ApplicationForms.zip' : data.attachments[0].fileName; 
        }
    } else {
        _downloadData.error = true;
    }
}

function setAsfFeeKillSwitch(response)
{
    _asfFormKillswitch = response && response.value === 'ON';
}

function setAsfCongratulationsPageKillSwitch(response)
{
    _asfCongratulationsPageKillswitch = response && response.value === 'ON';
}

function setCongratulationsPageDocumentKillSwitch(response)
{
    _congratulationsPageDocumentKillswitch = response && response.value === 'ON';
}

CongratulationsStore.dispatchToken = AppDispatcher.register((action) => {
    switch (action.actionType) {
        case ApplicationActionTypes.REVIEW_APPLICATION:
            _product = action.product;
            _investmentOptions = _.cloneDeep(_.get(action.formModel, 'form.investmentAllocation.investmentOptions', []));
            _inSpecieAccounts = _.cloneDeep(_.get(action.formModel, 'form.inSpecieTransfer.inSpecieAccounts', []));
            _adviceFee = _.cloneDeep(_.get(action.formModel, 'form.adviceFee', {}));
            break;
        //congratulations store only needs to get the form model used for submit application
        case ApplicationActionTypes.APPLICATION_SUBMIT_SUCCESS:
            applicationSubmitSuccess(action.data);
            break;
        case ActionTypes.DOWNLOAD_ALL:
            _downloadData.showSpinner = true;
            _downloadData.error = false;
            _downloadData.buttonDisabled = true;
            break;
        case ActionTypes.RESPONSE_DOWNLOAD_ALL:
            receiveDownloadedForm(action.data, true);
            _downloadData.showSpinner = false;
            _downloadData.error = action.isError;
            _downloadData.buttonDisabled = false;
            break;
        case ActionTypes.DOWNLOAD_FORM_SUCCESS:
            receiveDownloadedForm(action.data);
            break;
        case ActionTypes.DOWNLOAD_FORM_FAILED:
            _downloadData.error = true;
            break;
        case ActionTypes.CLEAR_DOWNLOAD:
            _downloadedForm = undefined;
            _downloadedFormFileName = undefined;
            break;
        case ApplicationActionTypes.ASF_FEE_KILLSWITCH_SUCCESS:            
            setAsfFeeKillSwitch(action.killSwitch);
            break;               
        case ApplicationActionTypes.ASF_FEE_KILLSWITCH_ERROR:                        
            break;
        case ApplicationActionTypes.ASF_CONGRATULATIONS_PAGE_KILLSWITCH_SUCCESS:            
            setAsfCongratulationsPageKillSwitch(action.killSwitch);
            break;               
        case ApplicationActionTypes.ASF_CONGRATULATIONS_PAGE_KILLSWITCH_ERROR:                        
            break;
        case ApplicationActionTypes.CONGRATULATIONS_PAGE_DOCUMENT_KILLSWITCH_SUCCESS:            
        setCongratulationsPageDocumentKillSwitch(action.killSwitch);
            break;               
        case ApplicationActionTypes.CONGRATULATIONS_PAGE_DOCUMENT_KILLSWITCH_ERROR:                        
            break;
        default:
            return true;
    }

    CongratulationsStore.emitChange();
    return true;
});

export default CongratulationsStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/CongratulationsStore.js